"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _defaultTheme = _interopRequireDefault(require("../../../defaultTheme"));
const StyledButtonPrimitiveContent = (0, _styledComponents.default)(({
  theme,
  loading,
  hasCenteredContent,
  onlyIcon,
  contentAlign,
  ...props
}) => /*#__PURE__*/React.createElement("div", props)).withConfig({
  displayName: "ButtonPrimitiveContent__StyledButtonPrimitiveContent",
  componentId: "sc-1nfggrh-0"
})(["", ""], ({
  contentAlign,
  loading
}) => (0, _styledComponents.css)(["visibility:", ";height:100%;display:flex;justify-content:", ";flex-basis:100%;align-items:center;"], loading && "hidden", contentAlign));
StyledButtonPrimitiveContent.defaultProps = {
  theme: _defaultTheme.default
};
const ButtonPrimitiveContent = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(StyledButtonPrimitiveContent, props, children);
var _default = ButtonPrimitiveContent;
exports.default = _default;